import recommend from '@algolia/recommend'
import { RelatedProducts } from '@algolia/recommend-react'
import { Button, Grid, Tooltip, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { showOffer } from '../../../../../redux/actions/offers'
import { IRootState } from '../../../../../redux/types'
import useScreenWidth from '../../../../shared/hooks/useScreenWidth'

const recommendClient = recommend(`${import.meta.env.VITE_ALGOLIA_ID}`, `${import.meta.env.VITE_ALGOLIA_KEY}`)
const indexName = 'offers'

const RecommendationContainer = styled('div')({
  display: 'flex',
  gap: '16px',
  marginTop: '16px'
})

const StyledImg = styled('img')({
  borderRadius: '8px 8px 8px 8px',
  maxWidth: '100%',
  cursor: 'pointer'
})

type OffersRecommendProps = {
  id: number
}

function RelatedItem({ item }: any) {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleShowOffer = (offerId: number) => {
    dispatch(showOffer(offerId))
  }

  return (
    <Tooltip title={item.title}>
      <Button
        sx={{ padding: 0, borderRadius: 2 }}
        onClick={() => {
          navigate(`/ofertas/${item.id}`)
          handleShowOffer(item.id)
        }}
      >
        <StyledImg src={`${encodeURI(`${import.meta.env.VITE_AWS_URL}/offers/${item.image}`)}`} alt={item.title} />
      </Button>
    </Tooltip>
  )
}

function ListView(props: any) {
  return (
    <>
      {props.items.map((item: any) => (
        <Grid item xs={6} md={4} key={item.objectID}>
          <props.itemComponent item={item} />
        </Grid>
      ))}
    </>
  )
}

function OffersRecommend({ id }: OffersRecommendProps) {
  const { t } = useTranslation(['global'])
  const isMobile = useScreenWidth(700)
  const { isAuth } = useSelector((state: IRootState) => state.auth)
  const { userBrands } = useSelector((state: IRootState) => state.brand)

  let filterBrands: string = ''
  userBrands.map((brand: any, index: number) => {
    if (index > 0) {
      filterBrands += ' OR '
    }
    filterBrands += `brand_id=${brand.id}`
  })

  return (
    <>
      {isAuth && userBrands.length > 0 && (
        <Grid container sx={{ marginTop: isMobile ? 2 : 3 }}>
          <Typography variant="subtitle1">{t('related-offers')}</Typography>
          <RelatedProducts
            view={ListView}
            classNames={{ root: RecommendationContainer.toString() }}
            maxRecommendations={3}
            translations={{ title: '' }}
            recommendClient={recommendClient}
            objectIDs={[`App\\Models\\Offer::${id}`]}
            indexName={indexName}
            itemComponent={RelatedItem}
            queryParameters={{ filters: filterBrands }}
          />
        </Grid>
      )}
    </>
  )
}

export default OffersRecommend
